import { ApiResponse } from "@/utils/ApiResponse";
import { validateResetTokenInterface } from "../interfaces/validateResetToken.interface";
import apiClient from "@/clients/apiClient";

export async function validateResetTokenAction(
  token: string
): Promise<ApiResponse<validateResetTokenInterface>> {      
    const { data } = await apiClient.post<validateResetTokenInterface>(
      "/auth/validate-reset-token",
      { token } 
    );  
    return {
      status: 200,
      data,
      message: "Token de restablecimiento validado correctamente",
    };
}                       